import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { RequirementToApproveContext } from "../components/Notifications/templates/RequirementPendingReviewClient";

export const selectorRequirementsToApproveNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle === NotificationHandleType.RequirementPendingReviewClient
    );
  }) as Array<WSNotificationResponse<RequirementToApproveContext>>;
};
